import React, { useState } from "react";
import { Container, Row, Col, Nav, Navbar } from "react-bootstrap";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";
import "../../App.css";

export default function Header(props) {
    const [pageSectionId, setPageSectionId] = useState(props.pageSectionId);
    const [navbar, setNavbar] = useState(false);

    const changebackground = () => {
        if (window.scrollY >= 66) {
            setNavbar(true);
        } else {
            setNavbar(false);
        }
    };

    window.addEventListener('scroll', changebackground);


    return (
        <>
            <Row className="header-margin">
                <Col>
                    <Navbar collapseOnSelect
                        expand="lg"
                        fixed="top"
                        bg="light"
                        variant="light"
                        id="headerbg"
                        className={navbar ? 'navbar active' : 'navbar'}>
                        <Container>
                            <Navbar.Brand href="https://www.swmc.com" target="_blank">
                                <img
                                    src="https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png"
                                    className="navBrandLogo img-fluid"
                                />
                            </Navbar.Brand>
                            <Navbar.Toggle aria-controls="basic-navbar-nav" />
                            <Navbar.Collapse id="basic-navbar-nav">
                                <Nav className="ms-auto mb-2 mb-lg-0 navbar-nav">
                                    <Nav.Link href={"/mydivorcelender#" + pageSectionId}>Home</Nav.Link>
                                </Nav>
                            </Navbar.Collapse>
                        </Container>
                        <UserWayAccessibilityMenu color="black" width={40} height={40} />
                    </Navbar>
                </Col>
            </Row>
        </>
    );
}